<template>
    <div>
        <div :key="pagePart.id" v-for="pagePart in items" v-if="canShow(pagePart)">
            <LazyHydrate when-visible :trigger-hydration="mustHydrateImmediately(pagePart)">
                <component :is="pagePart.componentName"
                           :pagePartId="pagePart.id"
                           :items="pagePartItems(pagePart)"
                           :classNames="pagePart.classNames"
                           :isOnlyForUser="pagePart.isOnlyForUser"
                           :isOnlyForGuest="pagePart.isOnlyForGuest"
                           :showPrintContentButton="pagePart.showPrintContentButton"
                           :showDownloadContentButton="pagePart.showDownloadContentButton"
                           :settings="pagePart.settings"
                           :componentContent="pagePart.componentContent"/>
            </LazyHydrate>
        </div>
    </div>
</template>

<script>
// const excludedLazyHydrateComponents = ['FavoriteGamesPromo', 'RecentGamesPromo', 'CategoryGames'];

export default {
    name: "PageParts",

    props: ['items'],

    computed: {
        user() {
            return this.$store.state.user;
        },
    },

    methods: {
        pagePartItems(pagePart) {
            return Array.isArray(pagePart.children) && pagePart.children.length && pagePart.children || pagePart.componentItems;
        },

        canShow(pagePart) {
            if (this.user){
                return !pagePart.isOnlyForGuest;
            }else {
                return !pagePart.isOnlyForUser;
            }
        },

        mustHydrateImmediately(pagePart) {
            return pagePart.contentTypeInterfaceId === 1;// || excludedLazyHydrateComponents.includes(pagePart.componentName);
        },
    },
}
</script>